import InfiniteScroll from "react-infinite-scroll-component";
import { PendingConnections } from "@/react/components/MemberDirectory/AllMembers/PendingConnections";
import { CommunityMember } from "@/react/components/shared/MembersList/CommunityMembers/ListView/CommunityMemberWithConnection/CommunityMember";
import { ListViewSkeleton } from "@/react/components/shared/MembersList/CommunityMembers/ListView/ListViewSkeleton";
import { useActiveConnections } from "@/react/hooks/useActiveConnections";
import { usePendingConnections } from "@/react/hooks/usePendingConnections";
import { PROFILE_SCROLLABLE_TARGET_ID } from "@circle-react/components/ProfileModalV3/Body";
import { EmptyState } from "./EmptyState";

const DEFAULT_ACTIVE_CONNECTIONS_COUNT = 10;
const DEFAULT_PENDING_CONNECTIONS_COUNT = 2;

export const ProfileConnections = () => {
  const {
    fetchNextPage,
    hasNextPage,
    audience: members,
    isLoading,
  } = useActiveConnections({
    perPage: DEFAULT_ACTIVE_CONNECTIONS_COUNT,
  });

  const {
    isLoading: isPendingConnectionsLoading,
    audience: pendingConnections,
  } = usePendingConnections({
    perPage: DEFAULT_PENDING_CONNECTIONS_COUNT,
  });

  if (isLoading || isPendingConnectionsLoading) {
    return <ListViewSkeleton count={DEFAULT_ACTIVE_CONNECTIONS_COUNT} />;
  }

  if (members.length === 0 && pendingConnections.length === 0) {
    return <EmptyState />;
  }

  return (
    <div className="flex flex-col gap-y-6">
      <PendingConnections />
      <InfiniteScroll
        style={{ overflow: "initial" }}
        scrollThreshold={0.5}
        next={fetchNextPage}
        hasMore={!!hasNextPage}
        loader={
          <div className="mt-4">
            <ListViewSkeleton count={DEFAULT_ACTIVE_CONNECTIONS_COUNT} />{" "}
          </div>
        }
        dataLength={members.length}
        scrollableTarget={PROFILE_SCROLLABLE_TARGET_ID}
      >
        <ul
          className="flex list-none flex-col gap-y-4"
          data-testid="directory_members_list"
        >
          {members.map(communityMember => (
            <CommunityMember
              communityMember={communityMember}
              key={communityMember.id}
              shouldShowHiddenMemberTooltip
            />
          ))}
        </ul>
      </InfiniteScroll>
    </div>
  );
};
